// Resend Configuration
// Determine if we're in production based on hostname
const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';

// Use relative URLs in production (same domain) or localhost for development
const getApiUrl = () => {
  // In development, always use proxy through relative URL
  if (!isProduction) {
    return '/api/send-email';
  }
  
  // First check for explicit environment variable
  if (process.env.REACT_APP_API_URL) {
    // Special case for client-only mode
    if (process.env.REACT_APP_API_URL === 'client-only') {
      return 'client-only';
    }
    return process.env.REACT_APP_API_URL;
  }
  
  // In production, use relative URL to work on both domains
  // This will work on both annuity-answers.vercel.app and www.annuityanswers.com
  return '/api/send-email';
};

const getHealthUrl = () => {
  // In development, use proxy through relative URL
  if (!isProduction) {
    return '/api/health';
  }
  
  if (process.env.REACT_APP_API_URL) {
    if (process.env.REACT_APP_API_URL === 'client-only') {
      return 'client-only';
    }
    return `${process.env.REACT_APP_API_URL.replace('/send-email', '')}/health`;
  }
  
  // In production, use relative URL to work on both domains
  // This will work on both annuity-answers.vercel.app and www.annuityanswers.com
  return '/api/health';
};

const API_URL = getApiUrl();
const HEALTH_URL = getHealthUrl();

console.log('=== RESEND CONFIG INITIALIZATION ===');
console.log('Environment:', isProduction ? 'PRODUCTION' : 'DEVELOPMENT');
console.log('Current hostname:', window.location.hostname);
console.log('Environment API URL:', process.env.REACT_APP_API_URL || 'Not set');
console.log('Using API endpoint:', API_URL);
console.log('Using health endpoint:', HEALTH_URL);
console.log('=====================================');

export const RESEND_CONFIG = {
  // API endpoint for your backend server
  API_ENDPOINT: API_URL,
  
  // Email recipient (all form submissions go here)
  RECIPIENT_EMAIL: 'jake@averillagencies.com',
  
  // Health check endpoint
  HEALTH_ENDPOINT: HEALTH_URL
};